export const getAge = (birth) => {
    var today = new Date();
    var birth_new = new Date(birth);
    var age = today.getFullYear() - birth_new.getFullYear();
    var m = today.getMonth() - birth_new.getMonth();

    if (m < 0 || (m === 0 && (today.getDate() < birth_new.getDate()))) {
        age--;
    }

    return age;
}